// extracted by mini-css-extract-plugin
export default {"select_custom_width":"styles_select_custom_width__sq3aZ"};